<template>
  <div class="main-content">
    <SideBarModal
        v-if="modalOpen"
        :user="selectedUser"
        :roles="roles"
        :tags="usersTags"
        :onModalClose="() => this.modalOpen = false"
    />
    <div class="card">
      <div class="card-body">
        <ManagersList
            v-if="!loading"
            :users="users.managers"
            :assists="users.managerAssist || []"
            :editUser="openSideModal"
        />
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import ManagersList from './components/ManagersList';
import SideBarModal from "@/components/modals/users/SideBarModal";

export default {
  components: {
    ManagersList,
    SideBarModal,
  },

  data() {
    return {
      loading: false,
      users: {},
      roles: null,
      usersTags: null,
      originalUsers: null,
      runnersData: null,
      modalOpen: false,
      selectedUser: null,
    }
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    async getUsers() {
      this.loading = true;
      const {data} = await api.index('users/list');
      if (data.success) {
        this.runnersData = data.runnersData;
        this.roles = data.roles;
        this.usersTags = data.tags;
        this.originalUsers = data.users;
        this.updateUsersList();
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loading = false;
    },
    openSideModal(user) {
      this.selectedUser = user;
      this.modalOpen = true;
    },
    updateUsersList() {
      let users = [...this.originalUsers];

      const filteredUsers = {};
      users.forEach((user) => {
        let filtered = false;
        user.roles.forEach((role) => {
          switch (role.name) {
            case 'runner':
            case 'chiefRunner':
            case 'postChiefRunner':
              filtered = true;
              break;
            case 'manager':
            case 'codManager':
              if (!filteredUsers.managers) filteredUsers.managers = {};
              filteredUsers.managers[user.id] = user;
              filtered = true;
              break;
            case 'managerAssist':
            case 'agentDivision':
            case 'agentReSeller':
              let roleName = role.name;
              if (role.name === 'agentReSeller') {
                roleName = 'agentDivision';
              }
              if (!filteredUsers[roleName]) filteredUsers[roleName] = {};
              filteredUsers[roleName][user.id] = user;
              filtered = true;
              break;
          }
        });
        if (!filtered) {
          if (!filteredUsers.others) filteredUsers.others = [];
          filteredUsers.others.push(user);
        }
      });

      this.users = filteredUsers;
    }
  }
}
</script>
